export default __webpack_public_path__ + "static/media/kayley.5d29d6cc.bin";